import MatchContainer from './MatchContainer';

export default MatchContainer;
